import React from 'react';
import PropTypes from 'prop-types';
import Label from 'src/components/HTKit/Forms/Parts/Label';
import SelectField from 'src/components/HTKit/Forms/SelectField';
import { FORM_SIZE } from 'src/components/HTKit/Forms/constants';
import { QTY_OPTIONS } from './constants';
import styles from '../styles.scss';

const CheckboxQuantitySelector = ({ selectedValue, answer, onChange }) => {
  const value = selectedValue ? selectedValue.get('quantity') || 1 : 1;
  /*
   *Prevent default when clicking the div because this is being rendered as a child of the CheckboxV2 component
   *and without preventDefault() it will toggle checkbox
   */
  return (
    <div className="marginTop-tiny1" onClick={(e) => e.preventDefault()}>
      <Label size={FORM_SIZE.extraSmall} dangerouslySetLabel="QTY" className="n700" />
      <SelectField
        className={styles.checkboxQuantity}
        options={QTY_OPTIONS}
        value={value}
        simpleValue
        clearable={false}
        searchable={false}
        onChange={({ value: newValue }) => {
          onChange(answer, newValue);
        }}
      />
    </div>
  );
};

CheckboxQuantitySelector.propTypes = {
  selectedValue: PropTypes.shape({
    get: PropTypes.func,
  }),
  answer: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

CheckboxQuantitySelector.defaultProps = {
  selectedValue: null,
  answer: null,
};

export default CheckboxQuantitySelector;
